export const MainViews = {
    SUMMARY: "summary",
    MONEYIN: "moneyin",
    EXPENSES: "expenses",
    SETTINGS: "setting",
    STATS : "stats"
}